module.exports = __webpack_public_path__ + "img/btn1@2x.cdadef54.webp";